import { useTheme } from '@/hooks/theme.hooks';

export const Backdrop = () => {
  const { theme } = useTheme();

  const BackdropComponent = theme?.backdrop.component;

  return <>{!!BackdropComponent && <BackdropComponent />}</>;
};
